module.exports = __webpack_public_path__ + "img/orman.e62b9f8d.png";